<script>
    import {twMerge} from "$m7-library/lib/twMerge";

    const {class: cls = "", width = "24", height = "24"} = $props()
</script>

<svg class={twMerge("tw:h-6 tw:w-6", cls)} width="{width}" height="{height}" viewBox="0 0 8 5" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M1 1L4 4L7 1" stroke="currentColor" stroke-width="1" stroke-linecap="round" stroke-linejoin="round"/>
</svg>